<template>
  <div class="form-page">
    <div class="form-page__header">
      <h2 class="form-page__title">Informationen zum Förderantrag</h2>
      <p class="form-page__subtitle">Arbeitsstipendien deutschsprachige Literatur</p>
    </div>

    <div class="form-section">
      <div class="info-box info-box--blue">
        <span class="info-box__icon">ℹ️</span>
        <div>
          <strong>Hinweis zur Bearbeitungszeit</strong>
          <p>Bitte beachten Sie: Bei einer Inaktivität von ca. 60 Minuten läuft Ihre Sitzung ab. Bitte speichern Sie Ihren Fortschritt regelmäßig.</p>
        </div>
      </div>

      <div class="info-box info-box--yellow" style="margin-top: 12px;">
        <span class="info-box__icon">⚠️</span>
        <div>
          <strong>Voraussetzungen für die Antragstellung</strong>
          <p>Das Arbeitsstipendium richtet sich an Autorinnen und Autoren, die ihren Hauptwohnsitz in Berlin haben und deutschsprachige Literatur veröffentlichen.</p>
        </div>
      </div>

      <div class="info-block" style="margin-top: 16px;">
        <h3 class="info-block__title">Das Stipendium umfasst:</h3>
        <ul class="info-block__list">
          <li>Förderung von Arbeitsvorhaben im Bereich der deutschsprachigen Literatur</li>
          <li>Stipendienzeitraum: 6 bis 12 Monate</li>
          <li>Monatliche Förderung zur Unterstützung des Schreibprozesses</li>
          <li>Keine Residenzpflicht – freie Arbeitseinteilung</li>
        </ul>
      </div>

      <div class="info-block">
        <h3 class="info-block__title">Erforderliche Unterlagen:</h3>
        <ul class="info-block__list">
          <li>Lebenslauf (tabellarisch)</li>
          <li>Veröffentlichungsliste (mind. ein veröffentlichtes Werk)</li>
          <li>Projektbeschreibung (max. 2 Seiten)</li>
          <li>Arbeitsproben (max. 20 Seiten)</li>
          <li>Nachweis des Hauptwohnsitzes Berlin</li>
        </ul>
      </div>
    </div>

    <div class="form-section">
      <h3 class="section-title">Bestätigung <span class="required-mark">*</span></h3>

      <label
        class="checkbox-label"
        :class="{ checked: modelValue.bestaetigung }"
      >
        <input
          type="checkbox"
          class="checkbox-input"
          :checked="modelValue.bestaetigung"
          @change="update('bestaetigung', $event.target.checked)"
        />
        Ich habe das Informationsblatt gelesen und erkenne die Ausschreibungsbedingungen an.
      </label>
      <p v-if="showErrors && !modelValue.bestaetigung" class="field__error" style="margin-top: 6px;">
        Bitte bestätigen Sie, dass Sie das Informationsblatt gelesen haben.
      </p>
    </div>

    <p class="required-note"><span class="required-mark">*</span> Pflichtfelder</p>
  </div>
</template>

<script>
export default {
  name: 'LitStep1',
  props: {
    modelValue: { type: Object, required: true },
    showErrors: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const update = (key, val) => emit('update:modelValue', { ...props.modelValue, [key]: val });
    return { update };
  },
};
</script>

<style scoped src="../form.css"></style>
